import clsx from 'clsx';
import React, { FC, useCallback, useRef } from 'react';

import { BasicModal } from '@/general/components/BasicModal/BasicModal';
import { Tabs } from '@/general/components/Tabs/Tabs';

import styles from './LicenseFinder.module.scss';

interface LicenseFinderProps {
  open: boolean;
  title: string;
  onClose?: () => void;
  tabs: string[];
  tabsContent: { id: number; title: string; card: string }[];
}

const LicenseFinder: FC<LicenseFinderProps> = ({ open = true, onClose, tabsContent, tabs, title }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const handleItemClick = useCallback(
    (index: number) => {
      if (scrollContainerRef.current === null) return;
      setActiveTab(index);

      // Get the container and clicked item
      const container = scrollContainerRef.current;
      const itemElement = container.children[index] as HTMLElement;

      // Calculate positions
      const containerRight = container.offsetWidth;
      const itemRight = itemElement.offsetLeft + itemElement.offsetWidth * 2;
      const itemLeft = itemElement.offsetLeft / 2;

      // Scroll if item is too far right or left
      if (itemRight > containerRight + container.scrollLeft) {
        container.scrollTo({
          left: itemRight - containerRight + 40, // Add padding
          behavior: 'smooth',
        });
      } else if (itemLeft < container.scrollLeft) {
        container.scrollTo({
          left: itemLeft - 40, // Subtract padding
          behavior: 'smooth',
        });
      }
    },
    [scrollContainerRef.current],
  );

  console.log('tabsContent[activeTab]tabsContent[activeTab]', tabsContent[activeTab]);

  return (
    <div className={styles.root}>
      <BasicModal isOpen={open} onClose={onClose} className={styles.root} id="licenseFinder-popup" title={title}>
        <div className={styles.groupContent}>
          <Tabs
            tabsId="LicenseFinder"
            tabs={tabs.map((tab, index) => ({
              id: tab,
              title: tab,
              content: (
                <div
                  className={styles.tabPanel}
                  role="tabpanel"
                  id={`tabpanel-${index}`}
                  aria-labelledby={`tab-${index}`}
                >
                  <div className={styles.contentCard}>
                    <img src={tabsContent[index].card} alt={`${tabsContent[index].title} card`} />
                  </div>
                  <p className={clsx('c-fs-caption', styles.contentTitle)}>{tabsContent[index].title}</p>
                </div>
              ),
              onClick: () => handleItemClick(index),
            }))}
          />
        </div>
      </BasicModal>
    </div>
  );
};

export default LicenseFinder;
